export default "__VITE_ASSET__D9JRjlin__"